<template>
  <div class="row column-s">
    <ul
      class="fast-menu row align-center justify-around hide-m hide-g"
      :class="[roll ? `active` : ``, showFastMenu ? '' : 'roll']"
    >
      <li @click="goTo('jobs')" :class="menu.jobs">Jobs em aberto</li>
      <li @click="goTo('shortcuts')" :class="menu.shortcuts">
        Atalhos rápidos
      </li>
      <li @click="goTo('stats')" :class="menu.stats">
        Estatísticas e insights
      </li>
    </ul>

    <div
      class="grid-6-m column jobs-container"
      :class="user.perfil == 'agregado_doutor' ? 'grid-9-g' : 'grid-8-g'"
    >
      <Jobs />
    </div>

    <div
      id="shortcuts"
      class="column grid-12 grid-6-m column-2"
      :class="user.perfil == 'agregado_doutor' ? 'grid-3-g' : 'grid-6-g'"
    >
      <Shortcuts class="short-margin" v-if="user.perfil == 'doutor'" />

      <div id="stats" class="stats-margin">
        <Stats />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Jobs from "@/components/Jobs.vue";
import Shortcuts from "@/components/Shortcuts.vue";
import Stats from "@/components/Stats.vue";
export default {
  name: "JobsView",
  components: {
    Jobs,
    Shortcuts,
    Stats,
  },
  data() {
    return {
      roll: false,
      showFastMenu: true,
      menu: {
        jobs: "active",
        shortcuts: "",
        stats: "",
      },
    };
  },
  methods: {
    goTo(content) {
      content =
        content === "jobs"
          ? 0
          : document.getElementById(content).offsetTop - 60;
      window.scrollTo({
        top: content,
        behavior: "smooth",
      });
      //document.getElementById(content).scrollIntoView({ behavior: "smooth" });
      this.menu = {
        jobs: "",
        shortcuts: "",
        stats: "",
      };

      this.menu[content] = "active";
    },
    handleScroll() {
      let scrollTimer = -1;
      this.showFastMenu = false;

      if (scrollTimer != -1) {
        clearTimeout(scrollTimer);
      }

      scrollTimer = window.setTimeout(() => (this.showFastMenu = true), 700);

      let y = window.scrollY;
      this.roll = y > 80 ? true : false;
      this.showFastMenu = y < 80 ? true : false;

      if (y < 700)
        this.menu = {
          jobs: "active",
          shortcuts: "",
          stats: "",
        };

      if (y > 700)
        this.menu = {
          jobs: "",
          shortcuts: "active",
          stats: "",
        };

      if (y > 900)
        this.menu = {
          jobs: "",
          shortcuts: "",
          stats: "active",
        };
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    ...mapGetters("user", ["user"]),
  },
};
</script>


<style lang="scss">
@use "@/assets/scss/vars.scss" as *;

.fast-menu {
  background: white;
  color: $font-color;
  list-style: none;
  font-size: 14px;
  position: absolute;
  width: 100%;
  left: 0px;
  height: 48px;
  top: 93px;
  z-index: 900;
  border-bottom-left-radius: 21px;
  border-bottom-right-radius: 21px;
  &.active {
    top: 0px;
    position: fixed;
  }

  &.roll {
    opacity: 0.3;
  }
  li {
    padding: 12px 0px;
    @media (max-width: $small) {
      padding: 0px;
      text-align: center;
      font-size: 12px
    }
  }
  .active {
    border-bottom: 5px solid $green-9;
  }
  @media (max-width: $small) {
    padding: 0px;
  }
}
.jobs-container {
  @media (max-width: $small) {
    margin-top: 90px;
  }
}
.column-2 {
  @media (min-width: $small) {
    margin-left: 38px;
  }
  @media (max-width: $small) {
    margin-top: 40px;
  }
}
.short-margin {
  margin-bottom: 43px;
}
</style>
